import ContentPage from '@/components/feature/ContentPage';

export default function DisclaimerPage() {
  return (
    <ContentPage
      title="Disclaimer"
      metaTitle="Disclaimer | CSSBuyBR.TOP"
      metaDescription="CSSBuyBR.TOP disclaimer. Independent resource not affiliated with CSSBuy. Read our full disclaimer."
      content={
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Independent Resource</h2>
            <p><strong>CSSBuyBR.TOP is an independent resource website and is not affiliated with, sponsored by, or officially endorsed by CSSBuy, its partners, or any related entities.</strong></p>
            <p className="mt-2">All content, guides, reviews, and resources provided on this website are created independently for educational and informational purposes.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">No Official Affiliation</h2>
            <p>We do not represent CSSBuy or speak on their behalf. Any references to CSSBuy, its services, or its products are for informational context only. Users should always verify current information, policies, and terms directly through official CSSBuy channels.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Information Accuracy</h2>
            <p>While we strive to provide accurate and helpful information, we cannot guarantee:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>That all information is current, complete, or error-free</li>
              <li>That prices, shipping costs, or policies mentioned are accurate</li>
              <li>That any coupon or discount information is valid or current</li>
              <li>That product descriptions or links remain active over time</li>
              <li>That any third-party service or seller is legitimate or safe</li>
            </ul>
            <p className="mt-2">Information on this site may become outdated. Always verify current details through official sources before making decisions.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">No Professional Advice</h2>
            <p>Content on this website does not constitute legal, financial, or professional advice. The information provided is general in nature and should not be relied upon as specific guidance for your individual situation.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">External Links and Risks</h2>
            <p>This website contains links to external websites, including our main website at kaspreadsheet.com and various category pages. We are not responsible for:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>The content, accuracy, or practices of any third-party website</li>
              <li>Any transactions, losses, or issues arising from visiting external links</li>
              <li>The safety or security of third-party websites</li>
              <li>Changes to third-party websites after we link to them</li>
            </ul>
            <p className="mt-2">Visiting external links is at your own risk. Always verify URLs and exercise caution when interacting with third-party services.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">User Responsibility</h2>
            <p>You are solely responsible for:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Verifying all information before making purchases</li>
              <li>Understanding the risks of international shopping</li>
              <li>Protecting your personal and financial information</li>
              <li>Complying with your local laws and customs regulations</li>
              <li>Any decisions or actions you take based on information from this site</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Limitation of Liability</h2>
            <p>CSSBuyBR.TOP and its operators shall not be held liable for any direct, indirect, incidental, or consequential damages arising from your use of this website or reliance on any information provided herein.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Contact</h2>
            <p>If you have questions about this disclaimer, please contact us through our contact page.</p>
          </section>

          <p className="text-sm text-foreground-500 italic">Last updated: August 26, 2026</p>
        </div>
      }
    />
  );
}